(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stat"] && !Shopify.designMode) return;
  try {
    class StatNumber extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.value || this.textContent).trim();
      const match = raw.match(/^(\D*)([\d.,]*\d)(\D*)$/);
      if (!match) return;

      const [, prefix, digits, suffix] = match;
      const target = parseInt(digits.replace(/\D/g, ''), 10);
      if (!target) return;

      const useThousands = /[.,]/.test(digits);
      const format = (value) => {
        const rounded = Math.round(value);
        return useThousands ? rounded.toLocaleString('pt-BR') : String(rounded);
      };

      this.textContent = prefix + format(1) + suffix;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.textContent = prefix + format(target) + suffix;
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          const duration = 1500;
          const start = performance.now();
          const step = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = 1 + (target - 1) * eased;
            this.textContent = prefix + format(current) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });

      observer.observe(this);
    }
  }

  customElements.define('stat-number', StatNumber);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonial-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const card = event.target.closest('.testimonial-card');
    if (!card) {
      return;
    }

    const video = card.querySelector('.testimonial-card__video');
    if (!video) {
      return;
    }

    // Card is already playing — clicking anywhere on it (the video itself,
    // since the button is hidden/unclickable while playing) pauses it.
    if (card.classList.contains('is-playing')) {
      video.pause();
      video.muted = true;
      card.classList.remove('is-playing');
      return;
    }

    // Only the "watch now" button starts playback on a paused card.
    const button = event.target.closest('.testimonial-card__watch');
    if (!button) {
      return;
    }

    // Only one card plays at a time — pause whichever one was playing before.
    document.querySelectorAll('.testimonial-card.is-playing').forEach((otherCard) => {
      const otherVideo = otherCard.querySelector('.testimonial-card__video');
      if (otherVideo) {
        otherVideo.pause();
        otherVideo.muted = true;
      }
      otherCard.classList.remove('is-playing');
    });

    video.muted = false;
    video.play();
    card.classList.add('is-playing');
  });
  } catch(e) { console.error(e); }
})();

})();
